<template>
  <main-header
    v-if="couponDetail"
    :title="$t('coupon-code.coupon-detail')"
    iconLeftBtn="el-icon-close"
    @onClickLeftBtn="onClickLeftBtn"
  >
    <el-row class="crm-redeem-bg">
      <el-col class="crm-redeem-entry is-membership-tier">
        <img
          width="100px"
          height="100px"
          :src="require('@/assets/img/reward.png')"
        />
        <h2 class="text-1-line ma-4">{{ couponDetail.name }}</h2>
        <div class="flex-center-r">
          <div class="branch-name">{{branchInfo.branchName}}</div>
        </div>
        <p v-html="$t('coupon-code.content-detail')"></p>
        <el-button type="text" icon="el-icon-warning-outline" class="branch-btn" @click="branchDrawerShow = true;">{{ couponDetail.isCouponMembership ? $t('coupon-code.privilege-branch') : $t('coupon-code.promotion-branch') }}</el-button>
      </el-col>
      <div class="crm-dot-left"></div>
      <div class="crm-dot-right"></div>
      <el-col>
        <el-radio-group v-model="radio1" class="flex-center-r custom-radio">
          <el-radio-button :label="1">{{$t('coupon-code.code')}}</el-radio-button>
          <el-radio-button :label="2">{{$t('coupon-code.qr-code')}}</el-radio-button>
        </el-radio-group>
      </el-col>
      <el-col class="crm-redeem-code-entry text-center" v-if="radio1 == 1">
        <h1 class="mt-2">{{ $t('coupon-code.redeem-code') }}</h1>
        <label>{{ couponCode.redeemCode }}</label>
        <el-button class="copy-redeem-code" @click="copyRedeemCode(couponCode.redeemCode)"><copy class="mr-2"/>{{$t('coupon-code.copy-redeem-code')}}</el-button>
      </el-col>
      <el-col v-if="radio1 == 2" class="flex-center-r">
        <qrcode
          :value="qrParam.token"
          :options="{
            errorCorrectionLevel: 'L',
            width: 160,
          }"
        ></qrcode>
      </el-col>
    </el-row>
    <el-col class="crm-redeem-timeout">
      <i class="el-icon-time"></i>
      &nbsp;
      <label v-if="couponDetail.isCouponMembership">{{ $t('coupon-code.timeout-membership-tier') }} {{ couponDetail.expiredDt }}</label>
      <label v-else>{{ $t('coupon-code.timeout') }} {{ timeout }} {{ $t('coupon-code.minutes') }}</label>
    </el-col>

    <privilege-branch :drawer="branchDrawerShow" :branchList="couponCode.branches" :closeDrawer="closeBranchDrawer"/>
  </main-header>
</template>
<script>
const moment = require("moment");
import { mapGetters, mapActions } from "vuex";
import MainHeader from "@components/MainHeader";
import PrivilegeBranch from "@components/coupon/PrivilegeBranch";
import Copy from "@components/icons/Copy";
import GATracking from "@/helper/GATrackingMixins";

export default {
  components: {
    MainHeader,
    PrivilegeBranch,
    Copy,
  },
  mixins: [GATracking],
  data() {
    return {
      isRedeem: true,
      isOpen: false,
      isTimeout: false,
      timeout: "00:00",
      clearTimeout: false,
      branchDrawerShow: false,
      radio1: 1,
      qrParam: {
        token: 'token',
        exp: null
      }
    };
  },
  async mounted() {
    this.trackActivity(9, 'RedeemCRMPromotion', 'view')
    // Not have promotion detail redirect to home page
    console.log(this.couponCode)
    if (this.couponDetail === null) {
      this.$router.push({
        name: "Home",
        params: {
          restaurant_aliase: this.restaurantUUID,
          branch_aliase: this.branchUUID,
        },
      });
    }
    await this.reQRcode()
    // Set count down redeem code
    this.setCountDown();
  },
  beforeDestroy() {
    clearInterval(this.clearTimeout)
  },
  methods: {
    ...mapActions({
      getMyCardQRCode: "user/getMyCardQRCode",
    }),
    onClickLeftBtn() {
      this.$router.push({ name: this.couponCodeView ? 'Coupon' : 'Home',
        params: this.couponCodeView ? {} : {
          restaurant_aliase: this.restaurantUUID,
          branch_aliase: this.branchUUID,
        }
      })
      if(!this.couponCodeView) this.trackActivity(10, 'RedeemCRMPromotion')
    },
    handlerRedeemCode() {
      this.isOpen = true;
    },
    closeDrawer() {
      this.isOpen = false;
    },
    closeBranchDrawer() {
      this.branchDrawerShow = false;
    },
    setCountDown() {
      if(!this.couponCode) this.$router.push({ name: 'Coupon' })
      const now = moment(this.couponCode.today); // moment('2021-06-07 00:01:55')
      const expiration = moment(this.couponCode.expiredDt); // moment('2021-06-07 00:02:00')
      const diff = expiration.diff(now) + 1000;
      var duration = moment.duration(diff, "milliseconds");
      var interval = 1000;
      if(duration.days() < 1) {
        this.clearTimeout = setInterval(() => {
          duration = moment.duration(duration - interval, "milliseconds");
          this.timeout = `${duration.minutes()}:${("0" + duration.seconds()).slice(-2)}`;
        }, interval);
        setTimeout(() => {
          this.$router.push({ name: this.couponCodeView ? 'Coupon' : 'Home',
            params: this.couponCodeView ? {} : {
              restaurant_aliase: this.restaurantUUID,
              branch_aliase: this.branchUUID,
            }
          })
        }, diff);
      } else {
        this.timeout = expiration.format('DD/MM/YYYY')
      }
    },
    copyRedeemCode(text) {
      navigator.clipboard.writeText(text);
    },
    async reQRcode() {
      await this.getMyCardQRCode({
        branchUUID: this.branchUUID,
        type: 2,
        redeemInfo: {
          redeemCode: this.couponCode.redeemCode,
          promotionRefKey: this.couponDetail.promotionRefKey
        }
      }).then(async (response) => {
        if (response) {
          this.qrParam = response
        }
      })
    }
  },
  computed: {
    ...mapGetters({
      couponDetail: "coupon/couponDetail",
      couponCode: "coupon/couponCode",
      couponCodeView: "coupon/couponCodeView",
      userInfo: "user/userInfo",
      restaurantUUID: "restaurant/restaurantUUID",
      branchUUID: "branch/branchUUID",
      branchInfo: "branch/branchInfo",
    }),
  },
};
</script>

<style scoped>
.crm-redeem-bg {
  background: #ffffff;
  border-radius: 16px;
  height: fit-content;
  margin: 0 16px;
  padding: 16px;
}

.crm-redeem-bg h1 {
  font-size: 24px;
  color: #828282;
  font-weight: 600;
  text-align: center;
  margin: 0;
}

.crm-redeem-bg label {
  font-size: 72px;
  color: #333333;
  text-align: center;
  font-weight: 500;
  display: block;
}

.crm-dot-left {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  top: 290px;
  left: -10px;
  position: absolute;
  background-color: var(--primary);
}

.crm-dot-right {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  top: 290px;
  right: -10px;
  position: absolute;
  background-color: var(--primary);
}

.crm-redeem-entry {
  text-align: center;
  margin: 0;
  padding-bottom: 50px;
  border-bottom: 2px dashed #c0c0c0;
}

.crm-redeem-entry.is-membership-tier {
  padding-bottom: 14px;
}

.crm-redeem-entry h2 {
  color: #232729;
  font-size: 26px;
  font-weight: 500;
}

.crm-redeem-entry p {
  color: #4f4f4f;
  font-size: 16px;
  font-weight: lighter;
}

.crm-redeem-timeout {
  color: #fefefe;
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  justify-items: center;
  margin-top: 16px;
}

.crm-redeem-timeout label {
  color: #fefefe;
  font-size: 22px;
  font-weight: lighter;
  margin-left: 5px;
}

.branch-btn {
  padding: 0 20px;
  color: #333333;
}

.branch-btn.el-button {
  font-family: "DB Heavent";
  font-size: 16px;
}

.copy-redeem-code {
  border-radius: 28px;
  font-family: "DB Heavent";
}

.branch-name {
  background: rgba(40, 183, 255, 0.2);
  border-radius: 26px;
  width: fit-content;
  padding: 6px 12px;
  color: var(--primary);
}

.flex-center-r {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

::v-deep .custom-radio .el-radio-button__inner {
  background-color: #DFE1E6;
  color: #828282;
  border-color: #DFE1E6;
  width: 118px;
  height: 36px;
  font-size: 16px;
  border: 2px solid #DCDFE6;
}

::v-deep .custom-radio .el-radio-button:first-child .el-radio-button__inner {
  border-radius: 6px 0 0 6px;
  border-left: 2px solid #DCDFE6;
}

::v-deep .custom-radio .el-radio-button:last-child .el-radio-button__inner {
  border-radius: 0 6px 6px 0;
  border-right: 2px solid #DCDFE6;
}

::v-deep .custom-radio .el-radio-button__orig-radio:checked+.el-radio-button__inner {
  background-color: #FFFFFF;
  color: #333333;
  border-color: #DFE1E6;
  box-shadow: -1px 0 0 0 #DFE1E6;
}
</style>
